<template>
    <div class="commute">
        <hr class="spacer half">
        <VehicleSelector
            :init_data="vehicle"
            v-model="vehicle"
            :update="notify_parent()"
        />
        <hr class="spacer half">
        <div v-if="answered_questions.includes('vehicle') && !['car', 'motorcycle'].includes(vehicle.vehicle)">    
            
            <VehicleCosts
            :vehicle="vehicle['vehicle']"
            :other_vehicle="vehicle['other_vehicle']"
            :init_data="vehicle_costs"
            v-model="vehicle_costs"
            :update="notify_parent()"
            />
            
        </div>
        <div v-if="answered_questions.includes('vehicle')">
            <h1>
            {{ $t('commute.title.commute_dist_calc_type') }}
            </h1>
               
            <CopyCommuteDistanceTimeFreq
            :other_commutes=other_commutes
            :this_commute_number=this_commute_number
            v-on:copy_to="copy_dist_time_freq($event)"
            />
            
            <br/>
            
            <CommuteDistanceTime 
            v-model="commute_dist_time"
            :init_data="commute_dist_time"
            :this_commute_number=this_commute_number
            :vehicle_movement_type="vehicle_movement_type"
            :vehicle_speed_floor="vehicle['speed_floor']"
            :vehicle_speed_ceiling="vehicle['speed_ceiling']"
            :update="notify_parent()"
            />
            <hr class="spacer half">
            
        </div>
        
        <div v-if="answered_questions.includes('commute_dist_type')  " class="bg calendar">    
            <h1>
                    {{ $t('commute.title.commute_freq_type') }}
            </h1>
            <RadioGroupPills  v-responsive.lg.xl.md 
                v-model="commute_freq_type"
                name="commute_freq_type"
                :change="notify_parent()"
                :div_classes=bootstrap_div_classes
                :default_val="commute_freq_type" :items=commute_freq_types />   

            <RadioGroup  v-responsive.sm.xs
                v-model="commute_freq_type"
                name="commute_freq_type"
                :change="notify_parent()"
                :div_classes=bootstrap_div_classes
                :default_val="commute_freq_type" :items=commute_freq_types />   
            
            <div>
                <div v-show="commute_freq_type === 'days_per_week'">
                    &nbsp; &nbsp; <input class="money" v-model=commute_freq_days_per_week type="number" min="1" max="7"> &nbsp;
                    {{ $t('commute-freq-types.days_per_week', {days: commute_freq_days_per_week}) }}
                </div>
                <div v-show="commute_freq_type === 'days_per_month'" >
                    &nbsp; &nbsp; <input class="money" v-model=commute_freq_days_per_month type="number" min="1" max="30"> &nbsp;
                    {{ $t('commute-freq-types.days_per_month', {days: commute_freq_days_per_month}) }}
                </div>
            </div>
            <hr class="spacer half">

        </div>


        <div v-if="answered_questions.includes('commute_dist_type') && answered_questions.includes('commute_freq_type') && ['car', 'motorcycle'].includes(vehicle.vehicle)">    
            <h1>
            {{ $t('commute.vehicle.costs') }} 
            </h1>
            <VehicleCosts
            :vehicle="vehicle['vehicle']"
            :other_vehicle="vehicle['other_vehicle']"
            :init_data="vehicle_costs"
            v-model="vehicle_costs"
            :update="notify_parent()"
            />
            <hr class="spacer">

        </div>
    </div>    
</template>

<script>
    import VehicleCosts from './VehicleCosts.vue'
    import VehicleSpeed from './VehicleSpeed.vue'
    import VehicleSelector from './VehicleSelector.vue'
    import CommuteDistanceTime from './CommuteDistanceTime.vue'
    import CopyCommuteDistanceTimeFreq from './CopyCommuteDistanceTimeFreq.vue'
    import RadioGroup from './RadioGroup.vue'
    import RadioGroupPills from './RadioGroupPills.vue'
    import ConvertedNumber from './ConvertedNumber.vue'
    import conversions from '../conversions.js'
    import settings from '../settings.js'
    
    import Persistent from '../mixins/Persistent.js'
        
    export default {
        components: {
            RadioGroup, RadioGroupPills, ConvertedNumber,
            CommuteDistanceTime, CopyCommuteDistanceTimeFreq,
            VehicleSelector, VehicleCosts, VehicleSpeed
        },
        mixins: [Persistent],
        data: function(){
            return {
                commute_freq_type : "",
                commute_freq_days_per_week : 5,
                commute_freq_days_per_month : 20,
                commute_type : "",
                commute_dist_time : {},
                commutes_per_day : 0,
                vehicle : {},
                vehicle_costs : {},
                complete : false
            }
        },
        props: {
            //init_data : Object,
            other_commutes: {
              type: Array,
              default: function () {
                return []
                }
            },
            this_commute_number: {
              type: Number,
              default: 1
            }
            
        },
        watch : {
            vehicle : {
                handler: function() {
                    this.vehicle_costs = {}
                },
                deep: true
            }
            
        },
        computed : {
        
            answered_questions : function(){
                let aq = []
                if(this.vehicle['vehicle'] != ""){
                    aq.push('vehicle')
                }
                if(this.vehicle_costs['data_complete']){
                    aq.push('vehicle_costs')
                }
                
                if(this.commute_freq_type != ""){
                    aq.push('commute_freq_type')
                }
                
                if(this.commute_dist_time['data_complete']){
                    aq.push('commute_dist_type')
                }
                    
                if(['car', 'motorcycle'].includes(this.vehicle['vehicle'])){
                    if(this.commute_dist_time['data_complete']){
                        aq.push('commute_dist_type')
                    }                
                    if((this.vehicle_costs['monthly_insurance'] + this.vehicle_costs['monthly_loan'] ) > 0){
                        aq.push('vehicle_costs')
                    }
                    
                    
                    if(this.vehicle_costs['energy_source'] !== ""){
                        aq.push('energy_source')
                    }

                } else {
                    aq.push('vehicle_costs')
                    aq.push('energy_source')

                }                
                
                
                return aq
            },
        
            vehicle_ic : function(){
                if(['car', 'motorcycle'].includes(this.vehicle['vehicle'])){
                    if(['gas', 'diesel', 'hybrid'].includes(this.vehicle_costs['energy_source'])){
                        return true
                    }
                }
                
                return false
            },
            
            vehicle_electric : function(){
                if(['car', 'motorcycle'].includes(this.vehicle['vehicle'])){
                    if(['electric'].includes(this.vehicle_costs['energy_source'])){
                        return true
                    }
                }
                if(['e-bicycle'].includes(this.vehicle['vehicle'])){
                    return true
                }                
                return false
            },
            vehicle_movement_type : function(){
                return this.vehicle['movement_type']
            },
            bootstrap_div_classes : function(){
                return "dbtn-group dbtn-group-toggle"
            },
            commute_types : function(){
                return [
                    {label: this.$t('commute-types.single_location'), value : 'single_location'}, 
                    {label: this.$t('commute-types.multi_location'), value : 'multi_location'}, 
                    {label: this.$t('commute-types.location_varies'), value : 'location_varies'}, 
                    {label: this.$t('commute-types.driver'), value : 'driver'}, 
                    {label: this.$t('commute-types.other'), value : 'other'}, 
                ]
            },
            commute_freq_types : function(){
                return [
                    {label: this.$t('commute-freq-types.regularly'), value : 'days_per_week'}, 
                    {label: this.$t('commute-freq-types.varies'), value : 'days_per_month'}
                ]                 
            },

        },
        methods: {
            copy_dist_time_freq: function(event){
                this.commute_dist_time = event['commute']['commute_dist_time']
                this.commute_freq_type = event['commute']['commute_freq_type']
                this.commute_freq_days_per_week = event['commute']['commute_freq_days_per_week']
                this.commute_freq_days_per_month = event['commute']['commute_freq_days_per_month']
            },
            
            notify_parent : function(){
                if(this.commute_freq_type == "days_per_week"){
                    this.commutes_per_day = parseFloat(this.commute_freq_days_per_week / 7);
                } else if(this.commute_freq_type == "days_per_month"){
                    this.commutes_per_day = parseFloat(this.commute_freq_days_per_month / (365.25/12))
                } else {
                    this.commutes_per_day = 0
                }

                this.complete = this.commutes_per_day > 0
                && this.answered_questions.includes('energy_source')
                && this.answered_questions.includes('vehicle')
                && this.answered_questions.includes('vehicle_costs');
                
                this.save_data()
            },
            convert: function(fn, ...args){
                return conversions[fn](...args);
            },
            display_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions['km2'+unit];
                    break;

                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }2
                        return conversions['l2'+unit];
                }
            },
            store_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2km']
                    break;
                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2l']
                }
            },
            settings : function(fn, ...args){
                return settings[fn](...args);
            }
        }
    }
    

</script>

<style>
div.commute_freq_type {
    swidth: 400px;
}

div.commute_freq_type > div {
    padding: .2em;
    border-radius: .2em;
}

</style>